import React, { Fragment } from 'react';
import { Row, Card, CardBody, CardTitle, Button } from 'reactstrap';
import { Colxx } from '../../common/CustomBootstrap';
import GlideComponent from '../../carousel/GlideComponent';
import IntlMessages from '../../../helpers/IntlMessages';
import {
    faImages,
    faEdit,
    faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LinkItem from './LinkItem';
import styled from "styled-components";

const HeroDiv = styled.div`
margin-bottom: 10px;
.herocard-image {
    width: calc(100% + 3px);
margin-left: -2px;
box-shadow: 0 0 4px rgba(0,0,0,0.2);
object-fit: cover;
height: 132px;
}

.herocard-container {
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
    max-width: 100%;
margin-left: 0%;
padding: 6px;
}

.herocard-text-area {
    padding: 10px;
}

.herocard-title-text {
    color: #444444;
    font-weight: bold;
    font-size: 17px;
    padding-bottom: 2px;
    width:  calc(100% + 20px);
}

.herocard-button-col-container {
    width:  calc(100% + 3px);
    margin-left: -2px;
}

.herocard-button-row-container {
    display: flex;
    width:  calc(100% + 3px);
    flex-direction: row;
    margin-left: -2px;
}

.herocard-button-row {
    flex: 1;
}

.herocard-button-row:not(:first-child) {
    border-left: 2px solid #e9eef4;
}

.herocard-button-row:not(:first-child):hover {
    border-left: 2px solid rgba(45,58,58,0);
}

.herocard-button-col {
    width: 100%;
}

.herocard-button {
    font-size: 15px;
border-top: 2px solid white;
text-align: center;
padding: 5px;
cursor: pointer;
}

.herocard-button:hover {
}
.below{
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
}
`;
const HeroCard = ({ index, url, caption, description, buttons, color }) => {
    function handleClick(path, type) {
        if (type === "openUrl" && path.includes(":Webview")) {
            var IndexWebview = path.split(":Webview");
            var Jsondata = JSON.parse(IndexWebview[1]);
            window.open(IndexWebview[0]);
        }
        else if (type === "openUrl" && !path.includes(":Webview")) {
            window.open(path);
        }
        else if (type === "messageBack") {
            var Jsondata = JSON.parse(path);
            window.open(Jsondata.url);
        }
    }
    return (
        <HeroDiv index={index}>
            <div className="herocard-container">
                {url !== undefined && url.map((c, i) => (
                    <img className="herocard-image" src={c.url} alt=""></img>
                ))}
                <div className="herocard-text-area">
                    <div className="ac-textBlock herocard-title-text">{caption}</div>
                    <div className="ac-textBlock">
                        <span>{description}</span>
                    </div>
                </div>
                <div className="herocard-button-col-container">
                    {buttons.map((c, index) =>
                        (() => {
                            switch (c.type) {
                                case "imBack":
                                    return (
                                        <div className={`herocard-button herocard-button-col ${index === buttons.length - 1 && ("")}`}
                                            style={{
                                                backgroundColor: color.heroButtonBackground,
                                                color: color.heroButtonText,
                                                cursor: "pointer"
                                            }}>{c.title}
                                        </div>
                                    );
                                case "messageBack":
                                    return (<div className={`herocard-button herocard-button-col ${index === buttons.length - 1 && ("")}`}
                                        onClick={() => handleClick(c.value, c.type)}
                                        style={{
                                            backgroundColor: color.heroButtonBackground,
                                            color: color.heroButtonText,
                                            cursor: "pointer"
                                        }}>{c.title}
                                    </div>);
                                case "openUrl":
                                    return (
                                        <div className={`herocard-button herocard-button-col ${index === buttons.length - 1 && ("")}`}
                                            onClick={() => handleClick(c.value, c.type)}
                                            style={{
                                                backgroundColor: color.heroButtonBackground,
                                                color: color.heroButtonText,
                                                cursor: "pointer"
                                            }}>{c.title}</div>);
                                default:
                                    break;
                            }
                        })()
                    )}
                </div>
            </div>
        </HeroDiv>
    );
};

const Showing = ({ senders, color, sildes }) => {
    const cardData = JSON.parse(sildes);

    return (
        <Fragment>
            <GlideComponent
                settings={{
                    gap: 5,
                    perView: 1,
                    keyboard: false,
                    // type: 'slider',
                    rewind: false,
                    // breakpoints: {
                    //   600: { perView: 1 },
                    //   1400: { perView: 2 },
                    // },
                }}
            >
                {cardData.map((silde, index) => {
                    return (
                        <div key={index}>
                            <HeroCard
                                sender={senders}
                                color={color}
                                index={index}
                                url={silde.content.images}
                                caption={silde.content.title}
                                description={silde.content.text}
                                buttons={silde.content.buttons}
                            ></HeroCard>
                        </div>
                    );
                })}
            </GlideComponent>
        </Fragment>
    );
};
export default Showing;
